import React, { useEffect, useState } from 'react';
import ExamTypeManagementPage from './ExamTypeManagementPage';
import QuestionManagementPage from './QuestionManagementPage';
import '../styles/admin-common.css';

interface QuestionBankManagementPageProps {
  initialTab?: 'exam-types' | 'questions';
  initialExamType?: string;
  initialQuestionId?: string;
}

const QuestionBankManagementPage: React.FC<QuestionBankManagementPageProps> = ({
  initialTab = 'questions',
  initialExamType,
  initialQuestionId,
}) => {
  const [activeTab, setActiveTab] = useState<'exam-types' | 'questions'>(initialTab);

  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  return (
    <div className="admin-page admin-page--question-bank">
      <header className="admin-page-title">
        <div>
          <span className="admin-page-title__eyebrow">관리자 워크스페이스</span>
          <h1>문제은행 관리</h1>
          <p>시험 유형, 문제 목록, 정답, 해설, 검수 상태를 관리합니다.</p>
        </div>
      </header>

      <section className="admin-section question-bank-panel">
        <div className="admin-management-tabs">
          <button
            className={`admin-management-tab ${activeTab === 'questions' ? 'active' : ''}`}
            onClick={() => setActiveTab('questions')}
          >
            문제 목록
          </button>
          <button
            className={`admin-management-tab ${activeTab === 'exam-types' ? 'active' : ''}`}
            onClick={() => setActiveTab('exam-types')}
          >
            시험 유형
          </button>
        </div>

        {activeTab === 'questions' ? (
          <QuestionManagementPage
            embedded
            initialExamType={initialExamType}
            initialQuestionId={initialQuestionId}
          />
        ) : (
          <ExamTypeManagementPage embedded />
        )}
      </section>
    </div>
  );
};

export default QuestionBankManagementPage;
